// S2-FE2: Input
import './Input.css';

export interface InputProps {
  label?: string;
  type?: 'text' | 'select' | 'textarea';
  placeholder?: string;
  helper?: string;
  value?: string;
  onChange?: (value: string) => void;
  options?: { value: string; label: string }[];
  rows?: number;
}

export function Input({
  label,
  type = 'text',
  placeholder,
  helper,
  value,
  onChange,
  options = [],
  rows = 3,
}: InputProps) {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    onChange?.(e.target.value);
  };

  return (
    <div className="airgent-input-group">
      {label && <label className="airgent-input-label">{label}</label>}

      {type === 'text' && (
        <input
          className="airgent-input"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
        />
      )}

      {type === 'select' && (
        <select
          className="airgent-input airgent-input-select"
          value={value}
          onChange={handleChange}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      )}

      {type === 'textarea' && (
        <textarea
          className="airgent-input airgent-input-textarea"
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          rows={rows}
        />
      )}

      {helper && <span className="airgent-input-helper">{helper}</span>}
    </div>
  );
}
